
<template>
  <div>
    <form v-on:submit.prevent="submitSearch">
      <div class="input-group input-group--search">
        <label for="input-search" class="input-group relative">
          <input
            type="text"
            class="input"
            id="input-search"
            :placeholder="$t('searchPlaceholderText')"
            v-model="query"
            v-on:blur="inputBlur"
            v-on:input="queryChange"
            autocomplete="off"
          >
          <div class="icon">
            <svg
              width="22px"
              height="22px"
              viewBox="0 0 40 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <title>Search Icon</title>
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <circle
                  class="icon__circle"
                  stroke="#000000"
                  stroke-width="2"
                  fill-rule="nonzero"
                  cx="16.5"
                  cy="16.5"
                  r="12.5"
                ></circle>
                <path
                  class="icon__line"
                  d="M24.5,26.5 L34.0480957,36.0480957"
                  stroke="#000000"
                  stroke-width="2"
                  stroke-linecap="square"
                  fill-rule="nonzero"
                ></path>
              </g>
            </svg>
          </div>
        </label>
        <div
          class="pl0 autocomplete-results absolute w-100"
          @mouseover="isHovering"
          @mouseleave="notHovering"
          v-show="isOpen"
        >
          <p class="ma0 suggestion-title pa3">{{$t('topArticlesText')}}</p>
          <ul class="ma0 pa3">
            <router-link
              v-for="(result, i) in results"
              :key="i"
              class="no-underline"
              :to="{name: 'article', hash: getHash(result)}"
              v-on:click.native="closeSuggestions"
            >
              <li class="autocomplete-result f6" v-html="result.htmlTitle"></li>
            </router-link>
          </ul>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { getLanguage, getPageHash, searchLocalArticles, formatArticleTitles } from '@/utils/common';

export default {
  data: () => {
    return {
      query: '',
      articles: [],
      results: [],
      isOpen: false,
      hovering: false
    };
  },
  created: function() {
    const matches = this.$route.hash.match(new RegExp('query' + '=([^&]*)'));
    this.query = matches ? decodeURIComponent(matches[1]).replace(/\+/g, ' ') : null;
  },
  methods: {
    getHash(article) {
      return getPageHash(article);
    },
    submitSearch() {
      const lng = getLanguage();
      const urlQuery = this.query.replace(/ /g, '+');
      this.closeSuggestions();
      this.$router.replace(`/${lng}/search#query=${urlQuery}`);
    },
    queryChange() {
      if (this.query === '') {
        this.isOpen = false;
        return;
      }
      this.filterResults();
    },
    filterResults() {
      const queries = this.query.split(' ').map(query => new RegExp(`(${query})`, 'i'));

      this.articles = searchLocalArticles(queries);
      const suggestions = formatArticleTitles(this.articles, this.query);

      if (suggestions.length === 0) {
        this.results = [];
        this.isOpen = false;
        return;
      }
      this.isOpen = true;
      this.results = suggestions.slice(0, 6);
    },
    inputBlur() {
      if (!this.hovering) {
        this.isOpen = false;
      }
    },
    closeSuggestions() {
      this.isOpen = false;
    },
    isHovering() {
      this.hovering = true;
    },
    notHovering() {
      this.hovering = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.input-group--search {
  text-align: left;
  display: block;
  margin: 0 auto;
  max-width: 85%;
  width: 100%;
  border-radius: 3px;
  border: none;
  color: #8a8c83;
  background: #fff;
  position: relative;
  box-shadow: 0 9px 22px 0px rgba(39, 39, 39, 0.08);

  .input {
    border: 0;
    font-size: 16px;
    height: 60px;
    width: 100%;
    padding: 1rem;
    font-weight: 400;
    padding-left: 20px;
    color: #8a8c83;
    padding-left: 20px;

    &::-webkit-input-placeholder {
      color: #8a8c83;
    }
    &:-moz-placeholder {
      color: #8a8c83;
    }
    &::-moz-placeholder {
      color: #8a8c83;
    }
    &:-ms-input-placeholder {
      color: #8a8c83;
    }
  }
  .icon {
    position: absolute;
    right: 1rem;
    top: 55%;
    transform: translateY(-50%);

    svg {
      .icon__circle,
      .icon__line {
        stroke: #828282;
      }
    }
  }
  &:focus {
    outline: none;
    border: none;
  }
}
.suggestion-title {
  border-bottom: 1px solid #f3f3f3;
}

@media (min-width: 426px) {
  .input-group--search {
    max-width: 45%;
  }
}

@media (min-width: 786px) {
  .input-group--search {
    max-width: 40%;
  }
  // .input-group--search {
  //   max-width: 40%;
  // }
}

//Results styles
.autocomplete-results {
  margin: 0;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  overflow: auto;
  background-color: #fff;
  top: 5.8rem;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
  color: #555;
}

.autocomplete-result:hover {
  background-color: #4aae9b;
  color: white;
}
</style>
